import React from 'react'
import './Styles.css'

const CustomInput = ({ icon, value, label, placeholder, onChange, ...props }) => {
  return (
    <div className="custom-input">
      {icon && <img src={icon} alt="select-icon" />}

      <div className="form-control">
        <label className="label">{label}</label>
        <input
          className="input"
          placeholder={placeholder}
          value={value}
          onChange={({ target }) => onChange(target.value)}
          {...props}
        />
      </div>
    </div>
  )
}

export default CustomInput
